import type * as yup from 'yup';

import { pkwSchema } from '@/features/Sparten/pkwv2/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = pkwSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const usePkwv2InputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'Pkwv2InputStore',
);
